import React from 'react';
import {ReactComponent as Icon} from 'images/icon/effectiveness/equals-sign.svg';
import {ReactComponent as IconInverted} from 'images/icon/effectiveness/equals-sign-inverted.svg';

export default function EqualsSignIcon({inverted}) {
  return inverted ? (
    <IconInverted className="icon equals-sign" />
  ) : (
    <Icon className="icon equals-sign" />
  );
}
